export class AttributesReader {

    public constructor(private element: HTMLElement) {
    }

    public getString(name: string, defaultValue: string = null): string {
        const attr = `data-${name}`;
        if (this.element.hasAttribute(attr)) {
            return this.element.getAttribute(attr);
        }
        else {
            return defaultValue;
        }
    }

    public getBool(name: string, defaultValue: boolean = false): boolean {
        const value = this.getString(name);
        if (value) {
            return value == "true";
        }
        return defaultValue;
    }

    public getNumber(name: string, defaultValue: number = 0): number {
        const value = this.getString(name);
        if (value) {
            return parseInt(value);
        }
        return defaultValue;
    }
}